<template>
  <div v-if="shouldRenderConfig" :class="getClassName">
    <appPageOptionContainer></appPageOptionContainer>
    <appPageOptionAllAttributesContainer
      v-if="0"
    ></appPageOptionAllAttributesContainer>
  </div>
</template>
<script>
import { useWebproductStore } from "@/stores/modules/webproduct";
import { useConfigStore } from "@/stores/modules/config";
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    ...mapState(useConfigStore, ["getMatrixComplete"]),
    ...mapState(useWebproductStore, ["getActiveProductPageOptions"])
  },

  methods: {
    getProductPageOptionValues: function (pageOption) {
      return this.getActiveProductPageOptions[pageOption].values;
    }
  }
};
</script>
